(function ($) {
	class W4D_TabsShowcase {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.showcases = $('.tabs-showcase');
		}

		bindEvents() {
			// Scope tabs per showcase instance to prevent cross-block interference
			this.showcases.each((_, showcase) => {
				const $showcase = $(showcase);
				$showcase.on('click', '.tabs-showcase__list-item', (e) => {
					this.handleTabClick(e, $showcase);
				});
			});
		}

		handleTabClick(e, $showcase) {
			const $clickedTab = $(e.currentTarget);
			const index = $clickedTab.data('tab-index');

			// Update tab states within this showcase only
			$showcase
				.find('.tabs-showcase__list-item')
				.removeClass('tabs-showcase__list-item--active')
				.attr('aria-selected', 'false');

			$clickedTab.addClass('tabs-showcase__list-item--active').attr('aria-selected', 'true');

			// Update content panels within this showcase only
			$showcase
				.find('.tabs-showcase__tab-content')
				.removeClass('tabs-showcase__tab-content--active')
				.attr('aria-hidden', 'true');

			$showcase
				.find('.tabs-showcase__tab-content[data-tab-index="' + index + '"]')
				.addClass('tabs-showcase__tab-content--active')
				.attr('aria-hidden', 'false');
		}
	}

	$(document).ready(() => new W4D_TabsShowcase());
})(jQuery);
